import type { UUID } from "utils";

const BASE_URL = "/accounts";

export const PAGE_URLS = {
  payments: `${BASE_URL}/payments`,
  paymentsNew: `${BASE_URL}/payments/new`,
  paymentDetails: `${BASE_URL}/payments/:id`,
  getLinkToPaymentDetails: (id: UUID) => `${BASE_URL}/payments/${id}`,
  paymentRefund: `${BASE_URL}/payments/:id/refund`,
  getLinkToPaymentRefund: (accountId: UUID, sourcePaymentId: UUID) =>
    `${BASE_URL}/payments/${sourcePaymentId}/refund?accountId=${accountId}`,
};
